@if (data.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}

<mat-dialog-content>
  @if (data.message) {
    <p>{{ data.message }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @for (action of data.actions; track action.action) {
    @switch (action.variant) {
      @case ('raised') {
        <button mat-raised-button [color]="action.color || 'primary'" (click)="onActionClick(action.action)">
          {{ action.text }}
        </button>
      }
      @case ('stroked') {
        <button mat-stroked-button [color]="action.color || 'primary'" (click)="onActionClick(action.action)">
          {{ action.text }}
        </button>
      }
      @case ('flat') {
        <button mat-flat-button [color]="action.color || 'primary'" (click)="onActionClick(action.action)">
          {{ action.text }}
        </button>
      }
      @default {
        <button mat-button [color]="action.color || 'primary'" (click)="onActionClick(action.action)">
          {{ action.text }}
        </button>
      }
    }
  }
</mat-dialog-actions>
